import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-xl border border-slate-700/60 bg-white/5 px-3 py-1 text-base text-white shadow-sm backdrop-blur-md transition-[border-color,box-shadow,background-color] duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-500 hover:bg-white/[0.07] focus-visible:outline-none focus-visible:border-[#FACC15]/80 focus-visible:bg-white/[0.08] focus-visible:shadow-[0_0_0_1px_rgba(250,204,21,0.5),0_0_18px_rgba(250,204,21,0.25)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
